import { Modal, ModalBody } from "reactstrap";
import { CommonText } from "../../../styledComponents/common";
import { ModalButtonSection } from "../../../styledComponents/members";
import { ColoredButton, WhiteButton } from "../../../styledComponents/buttons";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";


const DeleteModal = ({
  isOpen,
  toggle,
  handleDelete,
  isLoading,
  deleteIsLoading,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ marginTop: `25vh` }}>
      <ModalBody style={{ padding: `20px` }}>
        <CommonText style={{ paddingLeft: `15px` }}>
          Are you sure you want to delete this integration?
        </CommonText>
        <ModalButtonSection>
          <WhiteButton type="cancel" onClick={toggle}>
            Cancel
          </WhiteButton>
          <ColoredButton
            type="delete"
            padding={deleteIsLoading ? "0 15px" : "0 30px"}
            onClick={() => handleDelete()}
          >
            {deleteIsLoading ? (
              <ButtonTextLoader loadingText="Deleting" fontSize="13px" />
            ) : (
              "Delete"
            )}
          </ColoredButton>
        </ModalButtonSection>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
